module.exports = __webpack_public_path__ + "6bf7363370a59751d6af25bb05932b56.png";